import { useEffect } from 'react';
import fscreen from 'fscreen';
export function useFullscreenEvents(_a) {
    var enabled = _a.enabled, onFullscreenEntered = _a.onFullscreenEntered, onFullscreenExited = _a.onFullscreenExited;
    useEffect(function () {
        if ((!onFullscreenEntered && !onFullscreenExited) || !enabled) {
            return;
        }
        var handleFullscreenChange = function () {
            if (fscreen.fullscreenElement) {
                onFullscreenEntered && onFullscreenEntered();
                return;
            }
            onFullscreenExited && onFullscreenExited();
        };
        fscreen.addEventListener('fullscreenchange', handleFullscreenChange);
        return function () {
            return fscreen.removeEventListener('fullscreenchange', handleFullscreenChange);
        };
    }, [enabled, onFullscreenEntered, onFullscreenExited]);
}
//# sourceMappingURL=useFullscreenEvents.js.map